module.exports = __webpack_public_path__ + "static/media/image_certificate.9f59effe.png";